import React from 'react';
import SparkRunPageForm from './SparkRunPageForm';
import { useWorkspaceStore } from 'stores';
import { Box, GridProps } from '@mui/material';

type SparRunFormContainerProps = {
  formID?: string;
  addToSparkRunIDsCollection: (sparkRunID: string) => void;
  shouldRenderForm?: boolean;
  actionContainerStyles?: GridProps['sx'];
};

function SparRunFormContainer({
  formID,
  addToSparkRunIDsCollection,
  shouldRenderForm = true,
  actionContainerStyles,
}: SparRunFormContainerProps) {
  const currentWorkspaceID = useWorkspaceStore(
    React.useCallback((state) => state.currentWorkspaceID, [])
  );

  const [showForm, setShowForm] = React.useState(false);
  React.useEffect(() => {
    if (!shouldRenderForm) {
      setTimeout(() => {
        setShowForm(false);
      }, 1000);
    } else {
      setShowForm(true);
    }
  }, [shouldRenderForm]);

  return (
    <Box
      width='100%'
      height='100%'
      sx={{
        '.run_page_shadow': {
          display: showForm ? 'block' : 'none',
        },
      }}
    >
      {showForm && (
        <SparkRunPageForm
          workspaceID={currentWorkspaceID}
          formID={formID}
          addToSparkRunIDsCollection={addToSparkRunIDsCollection}
          actionContainerStyles={actionContainerStyles}
        />
      )}
    </Box>
  );
}

export default SparRunFormContainer;
